var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"red-reward-button"},[_c('div',{staticClass:"red-reward-group"},[_vm._m(0),_c('div',{staticClass:"chai-btn",on:{"click":function($event){return _vm.$emit('click')}}},[_c('span',{staticClass:"text-theme-black-650"},[_vm._v("拆")])])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"red-reward-text"},[_c('span',[_vm._v("答题感谢红包")])])
}]

export { render, staticRenderFns }